import { useTranslation } from 'libs/i18n';
import { AddAndRemoveButtons } from 'modules/onboarding/common/components/AddAndRemoveButtons';
import { initialOrderSubmissionContactType } from 'modules/onboarding/common/forms/orderSubmissionContacts';

import { useFormContext } from '../../../../forms/orderSubmissionContacts';

interface Props {
  index: number;
}

export const Buttons = ({ index }: Props) => {
  const { values, setValues } = useFormContext();

  const { t } = useTranslation();

  const onAdd = () => {
    values.orderSubmissionContacts.push({
      type: initialOrderSubmissionContactType,
      value: '',
      firstName: '',
      lastName: '',
      position: '',
    });
    setValues(values, false);
  };

  const onRemove = (index: number) => {
    values.orderSubmissionContacts.splice(index, 1);
    setValues(values, false);
  };

  return (
    <AddAndRemoveButtons
      addLabel={t('onboarding.orderSubmissionContacts.addContact')}
      counts={values.orderSubmissionContacts.length}
      index={index}
      removeLabel={t('onboarding.orderSubmissionContacts.removeContact')}
      onAdd={onAdd}
      onRemove={onRemove}
    />
  );
};
